(function () {
  function init(root) {
    if (!root || root.getAttribute('data-ready') === 'true') return;
    var track = root.querySelector('[data-mf-hc-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-mf-hc-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-mf-hc-dot]'));
    var prev = root.querySelector('[data-mf-hc-prev]');
    var next = root.querySelector('[data-mf-hc-next]');
    if (!track || slides.length < 2) return;
    root.setAttribute('data-ready', 'true');

    var current = 0;
    var timer = null;
    var lock = false;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var design = window.Shopify && window.Shopify.designMode;
    var auto = root.getAttribute('data-autoplay') === 'true' && !reduce && !design;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;

    function paint() {
      slides.forEach(function (s, i) {
        if (i === current) { s.removeAttribute('inert'); } else { s.setAttribute('inert', ''); }
      });
      dots.forEach(function (d, i) {
        if (i === current) { d.setAttribute('aria-current', 'true'); } else { d.removeAttribute('aria-current'); }
      });
    }

    function go(i, instant) {
      current = (i + slides.length) % slides.length;
      lock = true;
      track.scrollTo({ left: current * track.clientWidth, behavior: (instant || reduce) ? 'auto' : 'smooth' });
      paint();
      setTimeout(function () { lock = false; }, 700);
    }

    function start() {
      if (!auto || timer) return;
      timer = setInterval(function () { go(current + 1); }, interval);
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (lock || ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current && i >= 0 && i < slides.length) { current = i; paint(); }
      });
    }, { passive: true });

    if (prev) prev.addEventListener('click', function () { stop(); go(current - 1); });
    if (next) next.addEventListener('click', function () { stop(); go(current + 1); });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { stop(); go(i); });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    root.addEventListener('touchstart', stop, { passive: true });
    document.addEventListener('visibilitychange', function () {
      if (!document.body.contains(root)) return;
      if (document.hidden) { stop(); } else { start(); }
    });
    window.addEventListener('resize', function () {
      if (!document.body.contains(root)) return;
      track.scrollTo({ left: current * track.clientWidth, behavior: 'auto' });
    });
    document.addEventListener('shopify:block:select', function (e) {
      if (!document.body.contains(root)) return;
      var i = slides.indexOf(e.target);
      if (i > -1) { stop(); go(i, true); }
    });

    paint();
    start();
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-mf-hc]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
